import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalHook() {
  return <section className="py-24 md:py-32 bg-warm-white" data-id="element-47">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-48">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-49">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-50">
            <div className="aspect-square overflow-hidden" data-id="element-51">
              <img src="https://cdn.magicpatterns.com/uploads/3GiFe1HsCCExNLbyBNniCS/IMG_0476.jpg" alt="Panadera preparando pan de jamón artesanal" className="w-full h-full object-cover" data-id="element-52" />
            </div>
            <div className="absolute top-8 -right-8 w-full h-full border border-beige -z-10 hidden md:block" data-id="element-53"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-54">
            <h2 className="text-4xl md:text-5xl font-bold text-espresso mb-8 leading-tight" data-id="element-55">
              El pan no solo alimenta.
              <br data-id="element-56" />
              <span className="text-bakery-brown italic font-normal" data-id="element-57">
                También despierta recuerdos.
              </span>
            </h2>

            <div className="space-y-6 text-lg text-espresso/80 leading-relaxed" data-id="element-58">
              <p data-id="element-59">
                Hay un momento exacto en el que el aroma a pan recién horneado
                inunda la cocina. No es solo harina, agua y levadura
                transformándose con el calor; es la promesa de un hogar cálido,
                es el recuerdo de las tardes en familia, es la nostalgia de esa
                panadería de la esquina en tu país.
              </p>
              <p data-id="element-60">
                Hacer pan es un acto de amor y paciencia. Pero muchas veces, esa
                ilusión se desvanece cuando sacas del horno algo que no se
                parece a lo que soñabas. Un pan duro, una masa que no creció, un
                sabor que no te transporta a ningún lado.
              </p>
              <p data-id="element-61">
                Mereces sentir el orgullo de cortar una rebanada perfecta, de
                ver la miga suave y escuchar el crujir de la corteza dorada.
                Mereces recetas que honren tu tiempo, tus ingredientes y tu
                identidad.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}